<template>
  <div>
    <div v-show="bfloag1" class="overlay"></div>
    <!-- Overlay for the modal -->
    <div class="BlockList-W" v-show="bfloag">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close"
      />
      <div class="logintit">Bind wallet address</div>
      <div class="logintit1">
        USDT/DO locking must be done through a personal wallet and cannot be
        done directly through an exchange; otherwise, you will not be able to
        receive PRL-X.
      </div>
      <div class="loginbox">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="putext">
            <div class="bindtit">
              <div class="dian">.</div>
              USDT Lock-up Address:
            </div>
            <el-form-item prop="donationAddress">
              <el-input
                v-model.trim="form.donationAddress"
                class="inpttext"
                placeholder="Please provide your USDT Lock-up Address"
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext">
            <div class="putflex">
              <div class="puttit">select network:</div>
              <el-form-item label="" prop="coinType">
                <el-radio-group v-model="form.coinType">
                  <el-radio class="radiaos" :label="1" :disabled="radioDisabled"
                    >BNB</el-radio
                  >
                  <el-radio class="radiaos" :label="2" :disabled="radioDisabled"
                    >ERC-20</el-radio
                  >
                  <el-radio class="radiaos" :label="3" :disabled="radioDisabled"
                    >TRC-20</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </div>

          <div class="putext">
            <div class="bindtit">
              <div class="dian">.</div>
              Token/NFT receiving address :
              <!-- <span>(For receiving PRL-X)</span> -->
            </div>
            <el-form-item prop="xprlAddress">
              <el-input
                v-model.trim="form.xprlAddress"
                class="inpttext"
                placeholder="Please enter the locking address for DO."
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext">
            <div class="putflex">
              <div class="puttit">select network:</div>
              <el-form-item label="">
                <el-radio-group v-model="dotype">
                  <el-radio :label="1" :disabled="radioDisabled"
                    >DO Network</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </div>

          <div class="submit" @click="tijiao">Submit</div>
        </el-form>
      </div>
      <div class="Reminder">Friendly Reminder:</div>
      <div class="Reminderbox">
        <div class="Reminderleft">1.</div>
        <div class="Reminderright">
          <span>Address Binding:</span> Once the USDT locking address and the
          Token/NFT receiving address are bound, they cannot be changed or bound
          again.
        </div>
      </div>
      <!-- <div class="Reminderbox">
        <div class="Reminderleft">2.</div>
        <div class="Reminderright">
          <span> Token/NFT receiving Address:</span> Please make sure to fill in the
          correct Token/NFT receiving address. This is the token transfer address
          corresponding to the DO locking address; otherwise, you will not be
          able to receive PRL-X.
        </div>
      </div> -->
      <div class="Reminderbox">
        <div class="Reminderleft">2.</div>
        <div class="Reminderright">
          <span> Locking Requirements:</span> USDT/DO locking must be operated
          through a personal wallet and cannot be locked directly through an
          exchange; otherwise, you will not be able to receive PRL-X.
        </div>
      </div>
      <div class="Reminderbox">
        <div class="Reminderleft">3.</div>
        <div class="Reminderright">
          <span>Single Completion:</span> The locking transaction (USDT/DO) must
          be completed in one go and cannot be split into multiple transactions.
          For example, if you are locking 500U, splitting it into two
          transactions of 200U and 300U will not allow you to receive PRL-X.
        </div>
      </div>
      <div class="Reminderbox">
        <div class="Reminderleft">4.</div>
        <div class="Reminderright">
          <span>Quantity Regulation:</span> The amount of USDT and DO to be
          locked must comply with the official website's regulations. For
          example, locking 500U plus 2000DO entitles you to receive 500PRL-X,
          but locking 1000U plus 2000DO still only entitles you to receive
          500PRL-X.
        </div>
      </div>
      <div class="Reminderbox">
        <div class="Reminderleft">5.</div>
        <div class="Reminderright">
          <span> Multiple Locking:</span> Users can perform multiple locking
          operations. After each lock of 500U plus 2000DO, you can enter the
          locking transaction hash to receive 500PRL-X. Even if you perform a
          second locking with the same amount, you can still receive another
          500PRL-X using the new transaction hash.
        </div>
      </div>
    </div>
    <div class="BlockList-W1" v-show="bindfloag">
      <img
        class="imgs1"
        src="../../../assets/pc/Login/close.png"
        @click="close1"
      />
      <div class="bindbox">
        <div class="bindcons">
          Please confirm that your submission<br />
          information is accurate. Once<br />
          submitted and bound, modifications<br />
          will not be possible.
        </div>
        <div class="bindbtn">
          <div class="botton" @click="close1">close</div>
          <div class="botton1" @click="Confirms">Confirm</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBind } from "@/assets/server/api";

export default {
  props: ["bflog"],
  data() {
    const validateCoinType = (rule, value, callback) => {
      if (value === null || value === undefined) {
        callback(new Error("Please select a coin type"));
      } else {
        callback();
      }
    };
    return {
      radioDisabled: false,
      // formReadOnly: false,
      bfloag1: false,
      bindfloag: false,
      bfloag: false,
      userIds: "",
      dotype: 1,
      coinType: "",
      xprlAddress: "",
      donationAddress: "",
      jwtToken:"",
      form: {
        xprlAddress: "",
        donationAddress: "",
        coinType: "",
      },
      rules: {
        donationAddress: [
          {
            required: true,
            message: "donationAddress  is required",
            trigger: "blur",
          },
          {
            min: 32,
            max: 44,
            message: "donationAddress address error",
            trigger: "blur",
          },
        ],
        coinType: [
          { required: true, validator: validateCoinType, trigger: "change" },
        ],
        xprlAddress: [
          {
            required: true,
            message: "Token/NFT  is required",
            trigger: "blur",
          },
          {
            min: 38,
            max: 45,
            message: "Token/NFT receiving address error",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    if (
      this.userId !== "" ||
      this.userId !== null ||
      this.userId !== undefined
    ) {
      this.userId = localStorage.getItem("userId");
      this.jwtToken = localStorage.getItem("jwtToken");
      //console.log(this.userId);
    }
  },
  watch: {
    deep: true,
    bflog(val) {
      this.bfloag = val;
    },
    // userId(val){
    //   this.userIds=val;
    //   console.log(this.userIds);
    // }
  },
  methods: {
    close() {
      this.bfloag = false;
      this.$emit("bloginflog", this.bfloag);
    },
    close1() {
      this.bfloag1 = false;
      this.bindfloag = false;
    },
    tijiao() {
      // console.log(this.form);
      if (this.form.coinType == 1) {
        this.coinType = "BNB";
      } else if (this.form.coinType == 2) {
        this.coinType = "ERC-20";
      } else if (this.form.coinType == 3) {
        this.coinType = "TRC-20";
      }
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
        // console.log(this.form.coinType);
        if (this.form.coinType == "") {
          this.$message({
            message: "This coinType are not filled in",
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }

        if (success) {
          this.bfloag1 = true;
          this.bindfloag = true;
        } else {
          // this.$message(" This field are not filled in ");
          this.$message({
            message: "address error",
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }
      });
    },
    async Confirms() {
      // let config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //     jwtToken: this.jwtToken,
      //   },
      // };
      const params = {
        userId: localStorage.getItem("userId"),
        address: this.form.xprlAddress,
        donationAddress: this.form.donationAddress,
        coinType: this.coinType,
      };
      //console.log(params);
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
     // let data = await GetBind(formData,config);
      let data = await GetBind(formData);
      // console.log(data);
      if (data.code == 200) {
        this.xprlAddress = data.result.address;
        this.donationAddress = data.result.donationAddress;
        this.coinType = data.result.coinType;
        localStorage.setItem("isBindAddress", 1);
        this.$emit("xprl", this.xprlAddress);
        this.$emit("donation", this.donationAddress);
        this.$emit("isBind", 1);
        this.$emit("coinTypes", this.coinType);
        this.bfloag = false;
        localStorage.setItem("xprl", this.xprlAddress);
        localStorage.setItem("donation", this.donationAddress);
        localStorage.setItem("coinTypes", this.coinType);
        this.bfloag1 = false;
        this.bindfloag = false;
        this.bfloag = false;
        //   bfloag1:false,
        // bindfloag: false,
        // bfloag: false,
      } else {
        // this.$message(data.result);
        this.$message({
          message: data.result,
          type: "warning",
          customClass: "message-zindex",
        });
      }
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
/* Hide scrollbar for WebKit browsers */
.BlockList-W::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.BlockList-W {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.BlockList-W {
  width: 666px;
  height: 678px;
  overflow-y: auto;
  background: #151515;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  position: fixed;
  z-index: 99 !important;
  // border: 1px solid red;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .imgs {
    width: 18px;
    height: 18px;
    margin-left: 636px;
    margin-top: 10px;
  }
  .logintit {
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    margin-left: 30px;
  }
  .logintit1 {
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 14px;
    color: red;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    margin-left: 30px;
    margin-right: 30px;
  }
  .loginbox {
    width: 606px;
    margin: 0 auto;
    margin-top: 18px;
    .putext {
      .putflex {
        display: flex;
        height: 56px;
        margin-top: -10px;
        .puttit {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          margin-top: 10px;
          margin-right: 10px;
        }
      }
      .bindtit {
        display: flex;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.6);
        .dian {
          width: 6px;
          height: 6px;
          background: #3cf6f0;
          border-radius: 1px 1px 1px 1px;
          margin-top: 10px;
          margin-right: 6px;
        }
        span{
          font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-top: 4px;
        margin-left: 2px;
        display: inline-block;
        }
      }
      /deep/.el-radio__inner {
        background: none;
      }
      /deep/.el-radio__input.is-checked .el-radio__inner {
        background: none !important;
        border-color: #fff !important;
      }

      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #fff;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
      }
      /deep/.el-input__inner {
        border: none;
        background: #151515;
        border-bottom: 1px solid #5b5b5b;
        padding-bottom: 10px;
        padding-left: 0px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: #fff;
      }
      /deep/.el-input__inner::placeholder {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.3);
      }
    }
    .submit {
      width: 134px;
      height: 38px;
      line-height: 38px;
      background: #3cf6f0;
      border-radius: 81px 81px 81px 81px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 15px;
      color: #151515;
      text-align: center;
      margin-left: 244px;
      cursor: pointer;
    }
  }
  .Reminder {
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    margin-top: 8px;
    margin-left: 30px;
  }
  .Reminderbox {
    display: flex;
    margin-bottom: 8px;
    .Reminderleft {
      margin-left: 30px;
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 14px;
      color: #a1a1a1;
      line-height: 21px;
    }
    .Reminderright {
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 14px;
      color: #a1a1a1;
      line-height: 21px;
      margin-right: 30px;
      span {
        font-weight: 800;
        font-size: 14px;
      }
    }
  }
}
.BlockList-W1 {
  width: 365px;
  height: 242px;
  background: #151515;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  position: fixed;
  z-index: 999 !important;
  // border: 1px solid red;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -40%);
  .imgs1 {
    width: 18px;
    height: 18px;
    margin-left: 335px;
    margin-top: 12px;
  }
  .bindbox {
    width: 305px;
    margin: 0 auto;

    .bindcons {
      margin-top: 10px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 24px;
      text-align: center;
    }
    .bindbtn {
      display: flex;
      margin-top: 40px;
      .botton {
        width: 142px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        border-radius: 81px 81px 81px 81px;
        border: 1px solid #3cf6f0;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 15px;
        color: #3cf6f0;
        cursor: pointer;
      }
      .botton1 {
        width: 142px;
        height: 38px;
        background: #3cf6f0;
        border-radius: 81px 81px 81px 81px;
        line-height: 38px;
        text-align: center;
        cursor: pointer;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 15px;
        color: #151515;
        margin-left: 21px;
      }
    }
  }
}

.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;

  // .BlockList-Ws{
  //   width: 666px;
  //   height: 768px;
  //   background: #151515;
  //   opacity: 0.8;
  // }
}
</style>
